


















import { Component, Mixins } from "vue-property-decorator";

import LessonScore from "@/components/ReportResultTable/Score.vue";

import { IDiagnosticReportItem } from "@/models/interfaces/report-generator";
import ReportsMixin from "./Reports.mixin";

@Component({
  components: {
    LessonScore
  }
})
export default class LessonReport extends Mixins<
  ReportsMixin<IDiagnosticReportItem[]>
>(ReportsMixin) {
  private get tableColumns() {
    return [
      {
        value: "firstName",
        label: "First name"
      },
      {
        value: "lastName",
        label: "Last name"
      },
      {
        value: "username",
        label: "Username"
      },
      {
        label: "Suggested starting point",
        custom: true,
        name: "level"
      }
    ];
  }

  private generateCsvFile() {
    const headers = {
      firstname: "First name",
      lastname: "Last name",
      username: "Username",
      level: "Suggested starting point"
    };

    const data =
      this.reportData.map(item => ({
        firstname: item.firstName,
        lastname: item.lastName,
        username: item.username,
        level: `Level ${item.level}`
      })) || [];

    this.exportCSVFile(headers, data, this.title);
  }
}
